const getters = {
  sessionId(state) {
    return state.sessionId;
  },
  token(state) {
    return state.token ? state.token : localStorage.getItem('token');
  },
  phone(state) {
    return state.phone ? state.phone : localStorage.getItem('phone');
  },
  marketplaceInfo(state) {
    return state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
  },
  imageUrl(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.marketplaceLogoUrl;
  },
  isWalmart(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Flipkart Wholesale';
  },
  isColgate(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Colgate';
  },
  isOkCredit(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Ok Credit';
  },
  flagsData(state) {
    return state.flagsData ? state.flagsData : JSON.parse(localStorage.getItem('flagsData'));
  },
  tncUrl(state) {
    return state.flagsData ? state.flagsData?.tncUrl : JSON.parse(localStorage.getItem('flagsData')?.tncUrl);
  }
};
export default getters;
